import React from 'react'

export const StyledObject = ({
  text: { copy, style = '' },
  ignoreStyle = false,
}: {
  text: { copy: string; style?: string }
  ignoreStyle?: boolean
}) => <span className={ignoreStyle ? undefined : style}>{copy}</span>
